/**
 * Converts a hex color to RBG
 * @param hex
 * @returns {*}
 */

export const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

/**
 * Calculates whether a color should be black or white
 * based on background color
 * @param color
 * @returns {string}
 */

export const calculateTextColor = color => {
  const RBG = hexToRgb(color);
  const contrast = Math.round(
    (parseInt(RBG.r) * 299 + parseInt(RBG.b) * 587 + parseInt(RBG.g) * 114) / 1000
  );
  return contrast > 225 ? '#292727' : 'white';
};
